module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar-appointments-container"
  }, [_vm._l((_vm.list(_vm.day)), function(a, k) {
    return [(a.slot) ? _c('div', {
      staticClass: "full-w flex start space-between calendar-appointments-slot",
      style: ({
        top: ((a.offsetTop) + "px"),
        height: ((a.height) + "px")
      })
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('static.appointments.index.freeSlot')))]), _vm._v(" "), _c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.create(_vm.day)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('button.book')))])]) : _vm._e(), _vm._v(" "), (a.exception) ? _c('div', {
      staticClass: "full-w flex start space-between calendar-appointments-exception",
      style: ({
        top: ((a.offsetTop) + "px"),
        height: ((a.height) + "px")
      })
    }, [_c('span', [_vm._v(_vm._s(a.message || _vm.$t('static.appointments.index.exception')))])]) : _vm._e(), _vm._v(" "), (!a.slot && !a.exception) ? _c('v-appointment-card', {
      key: k,
      staticClass: "calendar-appointments-item",
      style: ({
        top: ((a.offsetTop) + "px"),
        height: ((a.height) + "px")
      }),
      attrs: {
        "fade": true,
        "appointment": a,
        "edit": _vm.edit(_vm.day)
      }
    }) : _vm._e()]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34afbf6e","hasScoped":false}!./src/app/components/calendarDay/calendarDay.html
// module id = 2967
// module chunks = 1